
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marine-algae/[category]/[name]",
      function () {
        return require("private-next-pages/marine-algae/[category]/[name].js");
      }
    ]);
  